
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"69","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".1","stroke":"#8F7A61","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M30.538 30.528c7.402 0 13.402-6.054 13.402-13.522s-6-13.522-13.402-13.522c-7.402 0-13.402 6.054-13.402 13.522s6 13.522 13.402 13.522zM3 66.322C3 51.267 15.09 39 30.08 39c14.991 0 27.08 12.197 27.08 27.322"}})])])
          )
        }
      }
    